
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    name: 'ProductVersionPricesTable',
})
export default class ProductVersionPricesTable extends Vue {
    @Prop({ default: false }) private readonly selectedEntity!: any;
    @Prop({ default: false }) private readonly isPricesModalVisible!: boolean;
    @Prop({ default: () => [] }) private readonly prices!: any[];

    private selectedProductIndex: number = 0;
    private selectedPriceType: string = 'price1';

    private mounted() {
        // Set defaults when component is mounted
        this.selectedProductIndex = 0;
        this.selectedPriceType = 'price1';
    }

    private closePricesModal() {
        this.$emit('closePricesModal');

        this.resetState();
    }

    private resetState() {
        this.selectedProductIndex = 0;
        this.selectedPriceType = 'price1';
    }

    private handleProductChange(value: number) {
        this.selectedProductIndex = value;
    }

    private handlePriceTypeChange(e: any) {
        this.selectedPriceType = e.target.value;
    }

    private downloadExcel() {
        // Implement the logic to download the current price data as an Excel file
        const data = this.currentPriceData;
        const header = this.headerRow;
        const filename = `${this.productName}_prices`;

        // Logic to convert data to Excel format and trigger download
        // This is a placeholder, implement actual logic here
        this.$emit('downloadExcelForPrices', { data, header, filename });
    }

    private get productName() {
        return this.prices[this.selectedProductIndex]?.name || '';
    }

    private get currentProduct() {
        return this.prices[this.selectedProductIndex] || null;
    }

    private get currentPriceData() {
        const priceData = this.currentProduct?.[this.selectedPriceType];

        if (priceData && priceData.length) {
            return priceData;
        } else {
            return [];
        }
    }

    private get headerRow(): number[] {
        if (!this.currentPriceData || !this.currentPriceData.length) return [];

        const headerRow = this.currentPriceData[0];

        if (headerRow[0] === 0) {
            headerRow.shift();
        }

        return headerRow;
    }

    private get dataRows(): any[][] {
        if (!this.currentPriceData || !this.currentPriceData.length) return [];

        return this.currentPriceData.slice(1);
    }
}
